var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-80",
            staticStyle: { width: "700px" },
            style: { maxHeight: _vm.getMaxHeightClient() + "px" },
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "modal-body m-4" },
              [
                _vm.isPopupActive
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "mr-0 pr-0",
                                attrs: { cols: "1" },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-file",
                                  staticStyle: { "font-size": "20px" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "pl-0", attrs: { cols: "4" } },
                              [
                                _c(
                                  "b",
                                  { staticStyle: { "font-size": "16px" } },
                                  [_vm._v(" Nom du fichier ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "justify-content-center" },
                          [_c("b-col", { attrs: { sm: "12" } }, [_c("hr")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "bandeaupp1 mb-3",
                                attrs: { sm: "12" },
                              },
                              [
                                _c("span", [_vm._v(" 200 lignes acceptées ")]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa-solid fa-check" }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "bandeaupp2 mb-3",
                                attrs: { sm: "12" },
                              },
                              [
                                _c("span", [_vm._v(" 150 lignes en erreur ")]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa-solid fa-xmark" }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "bandeaupp3 mb-3",
                                attrs: { sm: "12" },
                              },
                              [
                                _c("span", [
                                  _vm._v(" 150 lignes en attente de décision "),
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa-solid fa-pencil" }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "text-right",
                                attrs: { sm: "12" },
                              },
                              [_c("b", [_vm._v(" Total de 500 lignes ")])]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "justify-content-center mt-3" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "mt-3", attrs: { sm: "4" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.importOtherFile()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                Importer un autre fichier\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-3", attrs: { sm: "4" } },
                      [
                        _c("b-button", { staticClass: "btn" }, [
                          _vm._v(
                            "\n                Consulter ce lot\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-3", attrs: { sm: "4" } },
                      [
                        _c("b-button", { staticClass: "btn" }, [
                          _vm._v(
                            "\n                Configurer mes règles d'acceptance\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }